export const API_BASE_URL = import.meta.env.DEV
  ? '/user/v1/admin'
  : 'https://scout-service-v2.enter.de/user/v1/admin'
